<ng-template [cdkPortalOutlet]="dynamicLayoutPortal"></ng-template>
<app-tour-overlay *ngIf="isBrowser"></app-tour-overlay>
